import classNames from 'classnames';
import { ReactNode, useState } from 'react';

export type ToggleRowOption = {
  label: string | ReactNode;
  value: number;
  className?: string;
};

interface ToggleRowProps {
  options: ToggleRowOption[];
  selected?: number;
  onSelectionChange?: (value: number) => void;
  className?: string;
}

export default function ToggleRow({ options, selected, onSelectionChange, className }: ToggleRowProps) {
  const handleSelect = (value: number) => {
    onSelectionChange?.(value);
  };

  return (
    <div className={classNames(className, 'inline-flex self-start bg-gray-100 rounded-lg p-1 space-x-1')}>
      {options.map((option, index) => (
        <button
          key={index}
          onClick={() => handleSelect(option.value)}
          className={classNames(
            'px-4 py-2 rounded-md font-medium text-sm transition-all duration-200 ease-in-out',
            selected === option.value
              ? 'bg-white text-gray-900 shadow-sm transform scale-105'
              : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50',
            option.className,
          )}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
